module.exports = __webpack_public_path__ + "fonts/Darwin-BlackItalic.1977d08.woff";